import PropTypes from "prop-types";
import React, { useCallback, useEffect, useState } from "react";

//Import Scrollbar
import SimpleBar from "simplebar-react";
import graphBlack from "../../assets/images/restaurant-portal/graph-black.svg";
import graphOrange from "../../assets/images/restaurant-portal/graph-orange.svg";
import peopleBlack from "../../assets/images/restaurant-portal/people-black.svg";
import peopleOrange from "../../assets/images/restaurant-portal/people-orange.svg";
import settingOutline from "../../assets/images/sidebar/setting-outline.svg";
import settingOrange from "../../assets/images/sidebar/setting-orange.svg";
import logoutOutline from "../../assets/images/sidebar/logout-outline.svg";
import logoutOrange from "../../assets/images/sidebar/logout-orange.svg";
import ticketStarOutline from "../../assets/images/sidebar/ticket-star-outline.svg";
import ticketStarOrange from "../../assets/images/sidebar/ticket-star-orange.svg";
import gameOutline from "../../assets/images/sidebar/game-outline.svg";
import gameOrange from "../../assets/images/sidebar/game-orange.svg";
import locationOutline from "../../assets/images/sidebar/location-outline.svg";
import locationOrange from "../../assets/images/sidebar/location-orange.svg";
import chatOutline from "../../assets/images/sidebar/chat-outline.svg";
import chatOrange from "../../assets/images/sidebar/chat-orange.svg";

// MetisMenu
import MetisMenu from "metismenujs";
import withRouter from "../Common/withRouter";
import { Link, useLocation } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";

// API
import { post } from "../../api/axios";
import endpoints from "../../api/endpoints";

// Utils
import { extractErrorMessage } from "../../utils/errorHandler";

// Toast notifications
import toastr from "toastr";
import "toastr/build/toastr.min.css";

const AdminSidebarContent = (props) => {
  const [hoveredItem, setHoveredItem] = useState(null);
  const [focusedItem, setFocusedItem] = useState(null);

  // Configure toastr options
  toastr.options = {
    positionClass: "toast-bottom-left",
    timeOut: 5000,
    closeButton: true,
    progressBar: true,
  };

  const activateParentDropdown = useCallback((item) => {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      return false;
    }
    return false;
  }, []);

  const removeActivation = (items) => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;

      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
            ? parent.childNodes[1]
            : null;
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show");
        }

        parent.classList.remove("mm-active");
        const parent2 = parent.parentElement;

        if (parent2) {
          parent2.classList.remove("mm-show");

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove("mm-active"); // li
            parent3.childNodes[0].classList.remove("mm-active");

            const parent4 = parent3.parentElement; // ul
            if (parent4) {
              parent4.classList.remove("mm-show"); // ul
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove("mm-show"); // li
                parent5.childNodes[0].classList.remove("mm-active"); // a tag
              }
            }
          }
        }
      }
    }
  };

  const path = useLocation();
  const activeMenu = useCallback(() => {
    const pathName = path.pathname;
    let matchingMenuItem = null;
    const ul = document.getElementById("side-menu");
    const items = ul.getElementsByTagName("a");
    removeActivation(items);

    for (let i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  }, [path.pathname, activateParentDropdown]);

  const handleLogout = async (e) => {
    e.preventDefault();
    try {
      await post(endpoints.adminLogout || endpoints.logout, {});
      localStorage.removeItem("accessToken");
      localStorage.removeItem("user");
      toastr.success("Logged out successfully!");
      props.router.navigate("/login");
    } catch (error) {
      const errorMessage = extractErrorMessage(error);
      toastr.error(errorMessage);
    }
  };

  useEffect(() => {
    new MetisMenu("#side-menu");
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    activeMenu();
  }, [activeMenu]);

  return (
    <React.Fragment>
      <div className="sidebar-wrapper">
        <SimpleBar style={{ maxHeight: "calc(100% - 120px)" }}>
          <div id="sidebar-menu">
            <ul className="metismenu list-unstyled" id="side-menu">
              <li>
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a
                  href="javascript:void(0)" // eslint-disable-line no-script-url
                  className="has-arrow waves-effect"
                  onMouseEnter={() => setHoveredItem("members")}
                  onMouseLeave={() => setHoveredItem(null)}
                  onFocus={() => setFocusedItem("members")}
                  onBlur={() => setFocusedItem(null)}
                >
                  <img
                    src={
                      hoveredItem === "members" ||
                      focusedItem === "members" ||
                      path.pathname.includes("/admin/users")
                        ? peopleOrange
                        : peopleBlack
                    }
                    alt="users"
                  />
                  <span>{props.t("Members")}</span>
                </a>
                <ul className="sub-menu">
                  <li>
                    <Link to="/admin/users" className="waves-effect">
                      <span>{props.t("Active Members")}</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/users/deleted" className="waves-effect">
                      <span>{props.t("Deleted Members")}</span>
                    </Link>
                  </li>
                </ul>
              </li>
              <li>
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a
                  href="javascript:void(0)" // eslint-disable-line no-script-url
                  className="has-arrow waves-effect"
                  onMouseEnter={() => setHoveredItem("restaurants")}
                  onMouseLeave={() => setHoveredItem(null)}
                  onFocus={() => setFocusedItem("restaurants")}
                  onBlur={() => setFocusedItem(null)}
                >
                  <img
                    src={
                      hoveredItem === "restaurants" ||
                      focusedItem === "restaurants" ||
                      path.pathname.includes("/admin/restaurants")
                        ? locationOrange
                        : locationOutline
                    }
                    alt="restaurants"
                  />
                  <span>{props.t("Restaurants")}</span>
                </a>
                <ul className="sub-menu">
                  <li>
                    <Link to="/admin/restaurants" className="waves-effect">
                      <span>{props.t("Active Restaurants")}</span>
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/admin/restaurants/non-setup"
                      className="waves-effect"
                    >
                      <span>{props.t("Pending Setup Restaurants")}</span>
                    </Link>
                  </li>
                </ul>
              </li>
              <li>
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a
                  href="javascript:void(0)" // eslint-disable-line no-script-url
                  className="has-arrow waves-effect"
                  onMouseEnter={() => setHoveredItem("points")}
                  onMouseLeave={() => setHoveredItem(null)}
                  onFocus={() => setFocusedItem("points")}
                  onBlur={() => setFocusedItem(null)}
                >
                  <img
                    src={
                      hoveredItem === "points" ||
                      focusedItem === "points" ||
                      path.pathname.includes("/admin/points-ledger") ||
                      path.pathname.includes("/admin/points-redemption-tiers")
                        ? ticketStarOrange
                        : ticketStarOutline
                    }
                    alt="points"
                  />
                  <span>{props.t("Points & Rewards")}</span>
                </a>
                <ul className="sub-menu">
                  <li>
                    <Link to="/admin/points-ledger" className="waves-effect">
                      <span>{props.t("Points Ledger")}</span>
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/admin/points-redemption-tiers"
                      className="waves-effect"
                    >
                      <span>{props.t("Redemption Tiers")}</span>
                    </Link>
                  </li>
                </ul>
              </li>
              <li>
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a
                  href="javascript:void(0)" // eslint-disable-line no-script-url
                  className="has-arrow waves-effect"
                  onMouseEnter={() => setHoveredItem("financial")}
                  onMouseLeave={() => setHoveredItem(null)}
                  onFocus={() => setFocusedItem("financial")}
                  onBlur={() => setFocusedItem(null)}
                >
                  <img
                    src={
                      hoveredItem === "financial" ||
                      focusedItem === "financial" ||
                      path.pathname.includes(
                        "/admin/customer-financial-accounts",
                      ) ||
                      path.pathname.includes(
                        "/admin/restaurant-connect-accounts",
                      ) ||
                      path.pathname.includes("/admin/platform-fees") ||
                      path.pathname.includes("/admin/network-leakage")
                        ? graphOrange
                        : graphBlack
                    }
                    alt="financial"
                  />
                  <span>{props.t("Financial")}</span>
                </a>
                <ul className="sub-menu">
                  <li>
                    <Link
                      to="/admin/customer-financial-accounts"
                      className="waves-effect"
                    >
                      <span>{props.t("Customer Financial Accounts")}</span>
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/admin/restaurant-connect-accounts"
                      className="waves-effect"
                    >
                      <span>{props.t("Restaurant Connect Accounts")}</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/platform-fees" className="waves-effect">
                      <span>{props.t("Platform Fees")}</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/network-leakage" className="waves-effect">
                      <span>{props.t("Network Leakage")}</span>
                    </Link>
                  </li>
                </ul>
              </li>
              <li>
                <Link
                  to="/admin/games"
                  className="waves-effect"
                  onMouseEnter={() => setHoveredItem("games")}
                  onMouseLeave={() => setHoveredItem(null)}
                  onFocus={() => setFocusedItem("games")}
                  onBlur={() => setFocusedItem(null)}
                >
                  <img
                    src={
                      hoveredItem === "games" ||
                      focusedItem === "games" ||
                      path.pathname.includes("/admin/games")
                        ? gameOrange
                        : gameOutline
                    }
                    alt="games"
                  />
                  <span>{props.t("Games")}</span>
                </Link>
              </li>
              <li>
                <Link
                  to="/admin/faqs"
                  className="waves-effect"
                  onMouseEnter={() => setHoveredItem("faqs")}
                  onMouseLeave={() => setHoveredItem(null)}
                  onFocus={() => setFocusedItem("faqs")}
                  onBlur={() => setFocusedItem(null)}
                >
                  <img
                    src={
                      hoveredItem === "faqs" ||
                      focusedItem === "faqs" ||
                      path.pathname.includes("/admin/faqs")
                        ? chatOrange
                        : chatOutline
                    }
                    alt="faqs"
                  />
                  <span>{props.t("FAQs")}</span>
                </Link>
              </li>
              <li>
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a
                  href="javascript:void(0)" // eslint-disable-line no-script-url
                  className="has-arrow waves-effect"
                  onMouseEnter={() => setHoveredItem("settings")}
                  onMouseLeave={() => setHoveredItem(null)}
                  onFocus={() => setFocusedItem("settings")}
                  onBlur={() => setFocusedItem(null)}
                >
                  <img
                    src={
                      hoveredItem === "settings" ||
                      focusedItem === "settings" ||
                      path.pathname.includes("/admin/profile/activity-logs") ||
                      path.pathname.includes("/admin/settings")
                        ? settingOrange
                        : settingOutline
                    }
                    alt="settings"
                  />
                  <span>{props.t("Settings")}</span>
                </a>
                <ul className="sub-menu">
                  <li>
                    <Link
                      to="/admin/profile/activity-logs"
                      className="waves-effect"
                    >
                      <span>{props.t("Activity Logs")}</span>
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/settings" className="waves-effect">
                      <span>{props.t("Settings")}</span>
                    </Link>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </SimpleBar>
        <div className="sidebar-footer">
          <Link
            to="/logout"
            className="sidebar-logout-btn"
            onMouseEnter={() => setHoveredItem("logout")}
            onMouseLeave={() => setHoveredItem(null)}
            onFocus={() => setFocusedItem("logout")}
            onBlur={() => setFocusedItem(null)}
            onClick={handleLogout}
          >
            <img
              src={
                hoveredItem === "logout" || focusedItem === "logout"
                  ? logoutOrange
                  : logoutOutline
              }
              alt="logout"
            />
            <span>{props.t("Logout")}</span>
          </Link>
        </div>
      </div>
    </React.Fragment>
  );
};

AdminSidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(AdminSidebarContent));
